import FindEmployee from "components/ui/FindEmployee";
import Hero from "components/ui/Hero";
import Newsletter from "components/ui/Newsletter";
import Procedures from "components/ui/Procedures";
import React from "react";
import NumberCard from "components/ui/ByTheNumber";

const DefaultHomePage = () => {
  return (
    <>
      <Hero />
      <NumberCard />
      <Procedures />
      <Newsletter />
      <FindEmployee />
    </>
  );
};

export default DefaultHomePage;